import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Price } from '../Price.js';

var PriceWithAffix = (_param)=>{
    var { pricePrefix , priceSuffix  } = _param, priceProps = swcHelpers.objectWithoutProperties(_param, [
        "pricePrefix",
        "priceSuffix"
    ]);
    return /*#__PURE__*/ React.createElement("span", {
        className: "price-with-affix"
    }, pricePrefix, /*#__PURE__*/ React.createElement(Price, swcHelpers.extends({}, priceProps)), priceSuffix);
};

export { PriceWithAffix };
//# sourceMappingURL=PriceWithAffix.js.map
